import React from 'react';
import './assets/App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom'
import Band from './pages/Band'
import Favorites from './pages/Favorites'
import Home from './pages/Home'
import { Provider } from 'react-redux'
import store from './store'

function App() {
  return (
    <div className="App d-flex justify-content-center">
      <Router>
        <div className="container" style={{ color: 'white' }}>
          <div className="navbar navbar-dark bg-dark">
            <div className="navbar-header">
              <b className="navbar-brand">hacktiv-fy</b>
            </div>
            <ul className="nav">
              <li className="mx-3"><Link to="/">Home</Link></li>
              <li className="mx-3"><Link to="/favorites">Favorites</Link></li>
            </ul>
          </div>
          <Provider store={store}>
            <Switch>
              <Route path="/favorites">
                <Favorites />
              </Route>
              <Route path="/artist/:artistName">
                <Band />
              </Route>
              <Route exact path="/">
                <Home />
              </Route>
            </Switch>
          </Provider>
        </div>
      </Router>

    </div>
  );
}

export default App;
